import type { Comic } from '@/types/comic';

export const comics: Comic[] = [
  {
    id: 'c01',
    title: '我的室友是九尾狐',
    author: '白夜工作室',
    categories: ['romance', 'fantasy'],
    tags: ['灵异', '甜宠', '同居'],
    status: '连载',
    description: '只想过平凡大学生活的我，却和一只活了九百年的九尾狐成了室友。她白天是冷艳学姐，夜里却会露出九条毛茸茸的尾巴。当封印开始松动，我们被迫签下了一份跨越千年的契约。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20portrait%20illustration%20of%20an%20elegant%20girl%20with%20nine%20flowing%20fox%20tails%20glowing%20under%20dusk%20light%2C%20vibrant%20coral%20orange%20and%20deep%20teal%20palette%2C%20clean%20minimal%20background%2C%20soft%20cel%20shading%2C%20romantic%20fantasy%20atmosphere%2C%20highly%20detailed%20digital%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c01&orientation=portrait',
    latestChapter: '第87话 月下告白',
    chapterCount: 87,
    updateDate: '2026-10-08',
    popularity: 982000,
    rating: 9.4,
  },
  {
    id: 'c02',
    title: '契约婚约',
    author: '沈知夏',
    categories: ['romance', 'urban'],
    tags: ['契约', '先婚后爱', '都市'],
    status: '连载',
    description: '为救家族企业，她不得不与传闻中冷漠无情的总裁签下一纸婚约。本以为只是各取所需的交易，却在日复一日的相处里，发现那副冰冷面具下藏着一段只为她而写的温柔。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20portrait%20illustration%20of%20a%20confident%20young%20woman%20in%20an%20elegant%20formal%20dress%20holding%20a%20wedding%20contract%2C%20city%20skyline%20softly%20blurred%20behind%20her%2C%20warm%20orange%20and%20muted%20teal%20tones%2C%20clean%20minimal%20background%2C%20cel%20shading%2C%20modern%20drama%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c02&orientation=portrait',
    latestChapter: '第64话 迟来的真心',
    chapterCount: 64,
    updateDate: '2026-10-07',
    popularity: 876000,
    rating: 9.1,
  },
  {
    id: 'c03',
    title: '剑与晨星',
    author: '铁鳞',
    categories: ['fantasy', 'action'],
    tags: ['冒险', '魔法', '成长'],
    status: '连载',
    description: '少年在废土中拾起一柄会低语的残剑，从此踏上寻找失落晨星的旅途。巨龙盘踞的天空、被诅咒的王国，以及那把只有他能挥动的剑，都在呼唤着一个早已注定的名字。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20portrait%20illustration%20of%20a%20young%20swordsman%20holding%20a%20glowing%20legendary%20blade%20against%20a%20dramatic%20sunrise%20sky%2C%20epic%20fantasy%20cape%20and%20armor%2C%20vivid%20orange%20and%20deep%20teal%20color%20scheme%2C%20clean%20stylized%20background%2C%20cel%20shading%2C%20high%20detail%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c03&orientation=portrait',
    latestChapter: '第112话 破晓之刃',
    chapterCount: 112,
    updateDate: '2026-10-06',
    popularity: 754000,
    rating: 9.3,
  },
  {
    id: 'c04',
    title: '校园三角恋',
    author: '橘子汽水',
    categories: ['school', 'romance'],
    tags: ['青春', '暗恋', '社团'],
    status: '连载',
    description: '转学第一天，她就撞见了校园里最耀眼的两道身影。一个是温柔的学长，一个是别扭的同桌。社团活动、天台晚风、未说出口的心事，青春在三个人之间悄悄发酵。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20portrait%20illustration%20of%20three%20high%20school%20students%20in%20uniforms%20standing%20on%20a%20school%20rooftop%20at%20golden%20hour%2C%20soft%20breeze%20and%20warm%20sky%2C%20coral%20orange%20and%20fresh%20teal%20tones%2C%20clean%20minimal%20background%2C%20cel%20shading%2C%20youth%20romance%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c04&orientation=portrait',
    latestChapter: '第53话 天台的风',
    chapterCount: 53,
    updateDate: '2026-10-08',
    popularity: 690000,
    rating: 8.9,
  },
  {
    id: 'c05',
    title: '深夜食堂物语',
    author: '木下小满',
    categories: ['healing', 'urban'],
    tags: ['美食', '治愈', '群像'],
    status: '完结',
    description: '凌晨十二点，巷子深处的小店准时亮起暖黄的灯。老板不做菜单，只做客人心里想吃的味道。每一道菜背后，都是一段关于离别、重逢与释怀的故事。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20cozy%20midnight%20street%20food%20stall%20with%20warm%20lantern%20glow%2C%20steaming%20dishes%20on%20a%20wooden%20counter%2C%20gentle%20orange%20light%20and%20muted%20teal%20shadows%2C%20clean%20stylized%20background%2C%20soft%20cel%20shading%2C%20healing%20slice%20of%20life%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c05&orientation=portrait',
    latestChapter: '第120话 打烊之后',
    chapterCount: 120,
    updateDate: '2026-09-28',
    popularity: 512000,
    rating: 9.5,
  },
  {
    id: 'c06',
    title: '迷雾侦探',
    author: '灰鸦',
    categories: ['thriller', 'urban'],
    tags: ['推理', '悬疑', '单元剧'],
    status: '连载',
    description: '这座城市总是起雾。雾里有人失踪，有人撒谎，也有人抱着秘密死去。私家侦探程野接下了一桩看似普通的寻人委托，却一步步走进了一张精心编织的网。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20detective%20in%20a%20long%20coat%20standing%20in%20a%20foggy%20noir%20street%20lit%20by%20orange%20streetlight%2C%20moody%20teal%20mist%2C%20clean%20minimal%20background%2C%20cel%20shading%2C%20atmospheric%20mystery%20thriller%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c06&orientation=portrait',
    latestChapter: '第76话 雾中的影子',
    chapterCount: 76,
    updateDate: '2026-10-05',
    popularity: 623000,
    rating: 9.2,
  },
  {
    id: 'c07',
    title: '重生之豪门千金',
    author: '苏晚晴',
    categories: ['urban', 'romance'],
    tags: ['重生', '逆袭', '豪门'],
    status: '连载',
    description: '一觉醒来，她回到了被陷害的那一天。这一世，她不再做任人摆布的棋子。曾经欠她的，她要一笔一笔讨回来；而那个前世默默守护她的人，她也不想再错过。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20portrait%20illustration%20of%20a%20resolute%20young%20heiress%20in%20a%20luxurious%20ballroom%20gown%20with%20determined%20eyes%2C%20rich%20orange%20and%20cool%20teal%20lighting%2C%20clean%20minimal%20background%2C%20cel%20shading%2C%20modern%20city%20revenge%20drama%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c07&orientation=portrait',
    latestChapter: '第98话 棋盘翻转',
    chapterCount: 98,
    updateDate: '2026-10-07',
    popularity: 845000,
    rating: 8.8,
  },
  {
    id: 'c08',
    title: '九霄剑歌',
    author: '青冥客',
    categories: ['historical', 'action', 'fantasy'],
    tags: ['仙侠', '修真', '爽文'],
    status: '连载',
    description: '他本是宗门最不起眼的外门弟子，却在一次坠崖后得到上古剑灵的认可。从此剑指苍穹，逆天而行，九天之上的仙人也终将为他让路。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20young%20immortal%20cultivator%20in%20flowing%20robes%20standing%20on%20a%20cloud%20peak%20wielding%20a%20sword%20of%20light%2C%20epic%20orange%20sunset%20and%20teal%20mist%2C%20clean%20stylized%20background%2C%20cel%20shading%2C%20eastern%20fantasy%20xianxia%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c08&orientation=portrait',
    latestChapter: '第143话 一剑破天',
    chapterCount: 143,
    updateDate: '2026-10-06',
    popularity: 712000,
    rating: 9.0,
  },
  {
    id: 'c09',
    title: '猫咪恋人',
    author: '奶糖团子',
    categories: ['healing', 'romance'],
    tags: ['萌宠', '日常', '甜宠'],
    status: '连载',
    description: '楼下那只总来蹭饭的橘猫，某天突然变成了一个会脸红的少年。他说自己是被施了咒的猫族王子，而解开咒语的唯一办法，是找到真心爱他的人。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20cute%20fluffy%20orange%20cat%20sitting%20beside%20a%20shy%20blushing%20boy%20in%20a%20sunny%20apartment%2C%20warm%20cozy%20palette%20of%20coral%20and%20soft%20teal%2C%20clean%20minimal%20background%2C%20cel%20shading%2C%20sweet%20romance%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c09&orientation=portrait',
    latestChapter: '第45话 猫爪与心跳',
    chapterCount: 45,
    updateDate: '2026-10-08',
    popularity: 468000,
    rating: 9.3,
  },
  {
    id: 'c10',
    title: '暗夜契约',
    author: '夜行者',
    categories: ['thriller', 'fantasy'],
    tags: ['吸血鬼', '禁忌', '宿命'],
    status: '连载',
    description: '为了活下去，她与一位古老的血族签下了契约。白天是普通的学生，夜晚却是猎杀同类的猎手。当血月的真相逐渐浮现，她才发现自己从未是旁观者。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20an%20elegant%20vampire%20under%20a%20blood%20red%20moon%20with%20flowing%20dark%20cape%2C%20mysterious%20teal%20night%20mist%2C%20clean%20stylized%20background%2C%20cel%20shading%2C%20dark%20gothic%20fantasy%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c10&orientation=portrait',
    latestChapter: '第88话 血月之夜',
    chapterCount: 88,
    updateDate: '2026-10-04',
    popularity: 578000,
    rating: 9.0,
  },
  {
    id: 'c11',
    title: '我的青春修炼手册',
    author: '林小满',
    categories: ['school', 'healing'],
    tags: ['校园', '成长', '友情'],
    status: '完结',
    description: '高三那年，我们五个坐在同一间教室里，为梦想吵过架，也为彼此流过泪。这是一本关于青春、关于友情的修炼手册，写给每一个曾经笨拙努力的我们。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20group%20of%20five%20high%20school%20students%20laughing%20together%20in%20a%20sunlit%20classroom%2C%20nostalgic%20warm%20orange%20and%20fresh%20teal%20tones%2C%20clean%20minimal%20background%2C%20cel%20shading%2C%20youth%20friendship%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c11&orientation=portrait',
    latestChapter: '第72话 毕业那天',
    chapterCount: 72,
    updateDate: '2026-09-20',
    popularity: 402000,
    rating: 9.1,
  },
  {
    id: 'c12',
    title: '总裁的温柔陷阱',
    author: '甜栗子',
    categories: ['urban', 'romance'],
    tags: ['霸总', '甜宠', '误会'],
    status: '连载',
    description: '她只是想拿回属于自己的项目，却被那个高高在上的男人困在了层层温柔里。他说这是交易，可每一次靠近，都藏着连他自己都不敢承认的心动。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20portrait%20illustration%20of%20a%20handsome%20confident%20businessman%20in%20a%20suit%20beside%20a%20pretty%20young%20woman%2C%20modern%20office%20interior%20softly%20blurred%2C%20warm%20orange%20and%20cool%20teal%20tones%2C%20clean%20minimal%20background%2C%20cel%20shading%2C%20sweet%20urban%20romance%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c12&orientation=portrait',
    latestChapter: '第105话 迟到的告白',
    chapterCount: 105,
    updateDate: '2026-10-08',
    popularity: 923000,
    rating: 8.7,
  },
  {
    id: 'c13',
    title: '魔女的晚间杂货铺',
    author: '星野铃',
    categories: ['fantasy', 'healing'],
    tags: ['魔法', '治愈', '日常'],
    status: '连载',
    description: '在只有深夜才能找到的小巷尽头，经营着一家收留心愿的杂货铺。魔女用一杯茶、一颗糖，替来往的客人解开那些说不出口的烦恼。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20cozy%20magical%20evening%20grocery%20shop%20filled%20with%20glowing%20potions%20and%20herbs%2C%20a%20young%20witch%20behind%20the%20counter%2C%20warm%20amber%20orange%20and%20soft%20teal%20glow%2C%20clean%20stylized%20background%2C%20cel%20shading%2C%20healing%20fantasy%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c13&orientation=portrait',
    latestChapter: '第40话 会说话的茶壶',
    chapterCount: 40,
    updateDate: '2026-10-07',
    popularity: 356000,
    rating: 9.4,
  },
  {
    id: 'c14',
    title: '江湖不良人',
    author: '墨九',
    categories: ['historical', 'action'],
    tags: ['武侠', '恩怨', '江湖'],
    status: '连载',
    description: '一纸江湖令，引出十年前的血案。身负血海深仇的落魄剑客重返长安，周旋于门派与朝堂之间，只为查明当年灭门之夜真正的幕后之人。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20lone%20wandering%20swordsman%20in%20ancient%20chinese%20robes%20standing%20before%20a%20misty%20ancient%20city%20gate%2C%20orange%20lantern%20light%20and%20teal%20fog%2C%20clean%20stylized%20background%2C%20cel%20shading%2C%20wuxia%20martial%20arts%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c14&orientation=portrait',
    latestChapter: '第96话 剑指长安',
    chapterCount: 96,
    updateDate: '2026-10-05',
    popularity: 634000,
    rating: 9.1,
  },
  {
    id: 'c15',
    title: '谎言游戏',
    author: '黑匣子',
    categories: ['thriller', 'school'],
    tags: ['心理', '博弈', '反转'],
    status: '连载',
    description: '一场全校参与的匿名投票，让看似平静的校园陷入信任崩塌。每个人都在说谎，每个人都有动机。而真相，往往藏在最不起眼的那句真话里。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20high%20school%20students%20casting%20secret%20votes%20with%20tense%20expressions%2C%20dramatic%20orange%20and%20cold%20teal%20lighting%2C%20clean%20minimal%20background%2C%20cel%20shading%2C%20psychological%20mystery%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c15&orientation=portrait',
    latestChapter: '第58话 谁在说谎',
    chapterCount: 58,
    updateDate: '2026-10-08',
    popularity: 498000,
    rating: 9.2,
  },
  {
    id: 'c16',
    title: '星光下的告白',
    author: '夏栀',
    categories: ['romance', 'school'],
    tags: ['偶像', '追星', '青春'],
    status: '完结',
    description: '她是默默无闻的后援会会长，他是舞台上最耀眼的偶像。一次意外的相遇，让两条平行线有了交集。可当聚光灯亮起，喜欢一个人究竟要付出多少勇气。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20young%20idol%20under%20glowing%20stage%20lights%20beside%20a%20hopeful%20girl%20with%20light%20sticks%2C%20sparkling%20warm%20orange%20and%20fresh%20teal%20confetti%2C%20clean%20stylized%20background%2C%20cel%20shading%2C%20youth%20romance%20comic%20cover%20art&width=600&height=800&seq=hanman-cover-c16&orientation=portrait',
    latestChapter: '第66话 星光不灭',
    chapterCount: 66,
    updateDate: '2026-09-30',
    popularity: 421000,
    rating: 8.9,
  },
];